// extracted by css-extract-rspack-plugin
export default {"challenge-won":"challenge-won-Sf0r3u","challengeWon":"challenge-won-Sf0r3u","challenge-lost":"challenge-lost-ck8iz0","challengeLost":"challenge-lost-ck8iz0"};